import React, { useEffect, useState } from "react";

import useFetchData from "../../../hooks/UseFetchData";
import AppointmentsTable from "./AppointmentsTable";

const ViewAllAppointments = ({
  query,
  payloadData,
  setPayloadData,
  fetchAppointmentLIst,
  data,
  loading,
  dataref,
}) => {
  useEffect(() => {
    if (query) {
      setPayloadData({
        ...payloadData,
      });
    }
  }, [query]);

  return (
    <div ref={dataref}>
      <AppointmentsTable
        appointmentData={data}
        loading={loading}
        payloadData={payloadData}
        setPayloadData={setPayloadData}
        refetch={() => fetchAppointmentLIst(payloadData, query)}
      />
    </div>
  );
};
export default ViewAllAppointments;
